jQuery(document).ready(() => {
  $('.nav-primary .menu > li.dropdown').hover(
    function () {
      $(this).children().fadeIn();
    },
    function () {
      $(this).find('ul').fadeOut();
    }
  )

  $('.nav-primary .menu > li.dropdown > ul.dropdown-menu > li.dropdown').hover(
    function () {
      $(this).children().fadeIn();
    },
    function () {
      $(this).find('ul').fadeOut();
    }
  );

  $('.menu-item-has-children').each(function () {
    $(this).append('<span class="el-for-click"></span>');
  });

  $('.menu-toggler').click(() => {
    $('.header-mobile').toggleClass('header-mobile_on');
    $('.nav-mobile').toggleClass('open');
    $('body').toggleClass('scroll-none');
  });

  $(window).resize(() => {
    if ($('.nav-mobile').hasClass('open')) {
      $('.nav-mobile').removeClass('open');
      $('body').removeClass('scroll-none');
    }
  });

  $('.nav-mobile ul.menu li.dropdown > span').on('click', function (e) {
    $(e.target).closest('.dropdown').toggleClass('rotate');
    $(e.target).siblings().toggleClass('open');
  })
});


// WEBPACK FOOTER //
// ./scripts/modules/mobile-menu.js